<!-- loading overlay-->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="text-center spinner-wrapper">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div class="loading-seconds">
      {{ loadingSeconds }} seconds
    </div>
  </div>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="card mb-30">
      <div class="card-body">
        <app-add-more-filter-ranking [lstOption_Selected]="lstOption_Selected" [lstOption_States]="lstOption_States"
          [lstOption_IsUsed]="lstOption_IsUsed" (onUpdateChart)="onUpdateChart($event)"></app-add-more-filter-ranking>
      </div>

      <!--table content-->
      <div class="table-content">
        <div class="card-body">
          <div class="financial-metrics-table">
            <table class="table">
              <thead>
                <tr>
                  <th style="text-align: center">Value (MM JPY)</th>
                  <th>Value / % vs. LY (%)</th>
                  <th>Volume (Bottle) (K)</th>
                  <th>Volume (Bottle) / % vs. LY (%)</th>
                  <th>Price (Bottle) (JPY)</th>
                  <th>Price (Bottle) / Diff. vs. LY (JPY)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align: center"><strong>{{financialMetrics.value}}</strong></td>
                  <td [class]="financialMetrics.valueVsLyClass"><strong>{{financialMetrics.valueVsLy}}</strong></td>
                  <td><strong>{{financialMetrics.volume}}</strong></td>
                  <td [class]="financialMetrics.volumeVsLyClass"><strong>{{financialMetrics.volumeVsLy}}</strong></td>
                  <td><strong>{{financialMetrics.price}}</strong></td>
                  <td [class]="financialMetrics.priceVsLyClass"><strong>{{financialMetrics.priceVsLy}}</strong></td>
                </tr>
              </tbody>
            </table>
            <div style="margin-bottom: 30px;">
              <table class="table table-no-border">
                <thead>
                  <tr>
                    <th colspan="5">
                      <h2 style="font-weight: 600;">SKU Ranking *Top 100 only</h2>
                      <span style="font-size: 12px;font-weight: 500">Select items to add to the timeline chart </span>
                    </th>
                    <th colspan="10" class="header-action">
                      <span class="btn btn-sm btn-primary mt-1" style="margin-top: -1px !important; padding: 8px 8px;
              border-radius: 10px; background-color:  #3C7DFD ;border-color: #3C7DFD ;"
                        [ngClass]="{'disabled-btn': !selectedItems || selectedItems.length === 0}" (click)="applySelection()">Apply
                        to Timeline chart ({{ selectedItems?.length || 0 }})</span>
                    </th>
                  </tr>
                  <tr>
                    <th colspan="5" style="display:flex; align-items:center; height:100%;">
                      <div class="d-flex justify-content-end" style="align-items:center;">
                        <div style="padding-top: 12px;">
                          <span>Filter by brands</span>
                        </div>
                      </div>
                    </th>
                    <th colspan="10">
                      <div class="d-flex justify-content-end" style="align-items:center;">
                        <div class="maker-item" [ngClass]="{'boder-select': selectedMaker === 'ALL'}"
                          (click)="onMakerClick('ALL')">
                          <input type="radio" name="maker" value="ALL" [checked]="selectedMaker == null" />
                          ALL
                        </div>

                        <div class="maker-item" [ngClass]="{'boder-select': selectedMaker === 'COCA-COLA'}"
                          (click)="onMakerClick('COCA-COLA')">
                          <input type="radio" name="maker" value="COCA-COLA"
                            [checked]="selectedMaker === 'COCA-COLA'" />
                          COCA-COLA
                        </div>

                        <div class="maker-item" [ngClass]="{'boder-select': selectedMaker === 'SUNTORY'}"
                          (click)="onMakerClick('SUNTORY')">
                          <input type="radio" name="maker" value="SUNTORY" [checked]="selectedMaker === 'SUNTORY'" />
                          <!-- <span class="square color-suntory"></span> -->
                          SUNTORY
                        </div>

                        <div class="maker-item" [ngClass]="{'boder-select': selectedMaker === 'ASAHI'}"
                          (click)="onMakerClick('ASAHI')">
                          <input type="radio" name="maker" value="ASAHI" [checked]="selectedMaker === 'ASAHI'" />
                          <!-- <span class="square color-asahi"></span> -->
                          ASAHI
                        </div>

                        <div class="maker-item" [ngClass]="{'boder-select': selectedMaker === 'KIRIN'}"
                          (click)="onMakerClick('KIRIN')">
                          <input type="radio" name="maker" value="KIRIN" [checked]="selectedMaker === 'KIRIN'" />
                          <!-- <span class="square color-kirin"></span> -->
                          KIRIN
                        </div>

                        <div class="maker-item" [ngClass]="{'boder-select': selectedMaker === 'ITOEN'}"
                          (click)="onMakerClick('ITOEN')">
                          <input type="radio" name="maker" value="ITOEN" [checked]="selectedMaker === 'ITOEN'" />
                          <!-- <span class="square color-itoen"></span> -->
                          ITOEN
                        </div>

                        <div class="maker-item" [ngClass]="{'boder-select': selectedMaker === 'OTHER'}"
                          (click)="onMakerClick('OTHER')">
                          <input type="radio" name="maker" value="OTHER" [checked]="selectedMaker === 'OTHER'" />
                          <!-- <span class="square color-others"></span> -->
                          OTHER
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
           <div class="ranking-table-shell">
  <div class="ranking-table-scroll">
              <table class="table table-content table-content-th1">
                <thead>
                  <tr>
                    <th style="width: 50px; text-align: center;">
                      <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" />
                    </th>

                    <th (click)="sortData('SKU')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Product Name</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'SKU' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'SKU' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('MAKER')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Maker</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'MAKER' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'MAKER' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('VALUE')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Value (MM JPY)</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'VALUE' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'VALUE' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('VALUE_VS_LY')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Value / % vs. LY (%)</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'VALUE_VS_LY' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'VALUE_VS_LY' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('VALUE_COMP')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Value Comp. (%)</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'VALUE_COMP' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'VALUE_COMP' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('VALUE_COMP_TOTAL')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Value Comp. Total
                      (%)</span>
                        <div class="arrow">
                          <span class="arrow-up"
                            [class.active]="sortColumn === 'VALUE_COMP_TOTAL' && !sortReverse">▲</span>
                          <span class="arrow-down"
                            [class.active]="sortColumn === 'VALUE_COMP_TOTAL' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('COVERAGE')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Coverage (%)</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'COVERAGE' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'COVERAGE' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('COVERAGE_VS_LY')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Coverage / Diff.
                      vs. LY (%)</span>
                        <div class="arrow">
                          <span class="arrow-up"
                            [class.active]="sortColumn === 'COVERAGE_VS_LY' && !sortReverse">▲</span>
                          <span class="arrow-down"
                            [class.active]="sortColumn === 'COVERAGE_VS_LY' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('TURL_VALUE')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Turn (Val) (JPY)</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'TURL_VALUE' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'TURL_VALUE' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('TURL_VALUE_VS_LY')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Turn (Val) /
                      Diff. vs. LY (JPY)</span>
                        <div class="arrow">
                          <span class="arrow-up"
                            [class.active]="sortColumn === 'TURL_VALUE_VS_LY' && !sortReverse">▲</span>
                          <span class="arrow-down"
                            [class.active]="sortColumn === 'TURL_VALUE_VS_LY' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('TURL_BOTTLE')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Turn (Bottle)</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'TURL_BOTTLE' && !sortReverse">▲</span>
                          <span class="arrow-down" [class.active]="sortColumn === 'TURL_BOTTLE' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('TURL_BOTTLE_VS_LY')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Turn (Bottle) /
                      Diff. vs. LY</span>
                        <div class="arrow">
                          <span class="arrow-up"
                            [class.active]="sortColumn === 'TURL_BOTTLE_VS_LY' && !sortReverse">▲</span>
                          <span class="arrow-down"
                            [class.active]="sortColumn === 'TURL_BOTTLE_VS_LY' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('PRICE_BOTTLE')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Price (Bottle) (JPY)</span>
                        <div class="arrow">
                          <span class="arrow-up" [class.active]="sortColumn === 'PRICE_BOTTLE' && !sortReverse">▲</span>
                          <span class="arrow-down"
                            [class.active]="sortColumn === 'PRICE_BOTTLE' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                    <th (click)="sortData('PRICE_BOTTLE_VS_LY')" style="cursor:pointer;font-size: 10px;">
                      <div class="th-content">
                        <span>Price (Bottle)
                          / Diff. vs. LY (JPY)</span>
                        <div class="arrow">
                          <span class="arrow-up"
                            [class.active]="sortColumn === 'PRICE_BOTTLE_VS_LY' && !sortReverse">▲</span>
                          <span class="arrow-down"
                            [class.active]="sortColumn === 'PRICE_BOTTLE_VS_LY' && sortReverse">▼</span>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of skuRankingData" (click)="toggleSelection(item)" style="cursor: pointer;"
                    [ngClass]="[selectedItem === item ? 'highlight-row' : '',
                  'maker-row-'+ (item.MAKER || 'OTHER'),
                   (selectedItem != null && selectedItem !== item) ? 'dimmed-row' : '',
                   selectedMaker && item.MAKER !== selectedMaker ? 'dimmed-row' : '']">
                    <td style="text-align:center;" (click)="$event.stopPropagation()">
                      <input type="checkbox" [checked]="selectedItems.includes(item)"
                        (change)="toggleSelection(item)" />
                    </td>
                    <td data-toggle="tooltip" title="{{item.SKU}}"
                     [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'"
                      style=" max-width: 300px; text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      {{item.SKU}}</td>
                    <td style="text-align: left; min-width: 120px" [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{item.MAKER}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{formatValue(item.VALUE)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">
                      {{formatPercentage(item.VALUE_VS_LY)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{formatNoPercentage(item.VALUE_COMP)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{formatNoPercentage(item.VALUE_COMP_TOTAL)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{formatNoPercentage(item.COVERAGE)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">
                      {{formatPercentage(item.COVERAGE_VS_LY)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{formatPriceDiffNoSign(item.TURL_VALUE)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">
                      {{formatPriceDiff(item.TURL_VALUE_VS_LY)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{formatPriceNoYen(item.TURL_BOTTLE)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">
                      {{formatPercentageNo0(item.TURL_BOTTLE_VS_LY)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">{{formatPrice(item.PRICE_BOTTLE)}}</td>
                    <td [ngClass]="(item.MAKER === 'KIRIN' || item.MAKER === 'SUNTORY' || item.MAKER === 'OTHER') ? 'maker-main' : 'maker-other'">
                      {{formatPriceDiff(item.PRICE_BOTTLE_VS_LY)}}</td>
                  </tr>
                </tbody>
              </table>

            </div>
</div>

            <div class="d-flex justify-content-between mt-4 hide-pdf-print">
              <span class="btn btn-sm btn-primary mt-1" style="margin-top: -1px !important; padding: 8px 8px;
              border-radius: 10px;background-color:  #3C7DFD ;border-color: #3C7DFD ;"
                [ngClass]="{'disabled-btn': !selectedItems || selectedItems.length === 0}" (click)="applySelection()">Apply to
                Timeline chart ({{ selectedItems?.length || 0 }})</span>

              <download-button [ngClass]=" isLoading ? 'disable-button' :''">
                <a #downloadLink style="display: none;"></a>
                <button *ngIf="!isLoading" ngbDropdownItem (click)="exportListRanking_CSV_by_Url()">
                  Download CSV
                </button>
              </download-button>
            </div>
          </div>
        </div>

        <app-sku-ranking-timeline
          *ngIf="(!isLoadingTimeline && skuRankingTimelineData && skuRankingTimelineData.length > 0)"
          [class]="isShowChard ? '' :  'd-none'" [chartData]="skuRankingTimelineData"
          [selectedDateType]="selectedDateType"
          [onDownloadDetail]="exportDetailRanking_CSV_by_Url.bind(this)"></app-sku-ranking-timeline>


      </div>
    </div>
  </div>